export const meta = { id: 'O17', slug: 'gestao-jornadas', title: 'Conheça Gestão de Jornadas', description: 'Entenda como Jornadas organizam experiências de desenvolvimento em um percurso.', profile: 'owner', category: 'jornadas', type: 'screen', status: 'published', order: 470, keywords: ['jornadas','trilha','percurso','desenvolvimento'], previous: 'O16', next: 'O18', related: ['O18','O19','A05'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Conheça Gestão de Jornadas

A Jornada organiza experiências de desenvolvimento em um caminho coerente para o participante.

<HelpImage pendingId="O17.1" alt="Tela de Gestão de Jornadas" />

Uma Jornada pode se relacionar com conteúdos e Formações já existentes, além de apoiar a execução do Plano e o acompanhamento do progresso.

<Callout type="concept">Treinamento ensina. Formação estrutura um programa. Jornada organiza o caminho.</Callout>
